// extracted by mini-css-extract-plugin
module.exports = {"coachItem":"CoachItem_coachItem__2Fcn0","info":"CoachItem_info__3rukh"};